import { type MutationHookOptions, useMutation } from "@apollo/client";
import { RotateCCBillWebhookSecretMutation } from "../graphql/mutations";
import type {
  RotateCcBillWebhookSecretMutationType,
  RotateCcBillWebhookSecretMutationVariablesType,
} from "@/types/graphql/partner.generated";

export const useRotateCCBillWebhookSecretMutation = (
  options?: MutationHookOptions<
    RotateCcBillWebhookSecretMutationType,
    RotateCcBillWebhookSecretMutationVariablesType
  >
) => {
  return useMutation<
    RotateCcBillWebhookSecretMutationType,
    RotateCcBillWebhookSecretMutationVariablesType
  >(RotateCCBillWebhookSecretMutation, options);
};
